export class OrderXmlModel {
    invoiceId: string = ''
    xml: string = ''

    constructor(o?:Partial<OrderXmlModel>) {
        Object.assign(this, o)
    }

    hasXml():boolean {
        return !!this.xml
    }

    setXml(xml:string):void {
        this.xml = xml
    }
}
